import './src/scss/theme.scss'
import './src/scss/KCM.scss'
import('../../src/js/app')
